import React from 'react';

export const FormMessage = (props) => {
  return (
    <div style={props.style} className={`${props.className ? props.className : ''} form-message form-message--${props.extraClass}`}>
      <div className="form-message__icon"></div>
      <div className="form-message__text">
        { props.children }
      </div>
    </div>
  );
};
